(function() {
  var module;

  try {
    // Get current templates module
    module = angular.module('manager');
  } catch (error) {
    // Or create a new one
    module = angular.module('manager', []);
  }

  module.run(['$templateCache', function($templateCache) {
    return $templateCache.put('components/newUser/newUser.tpl.html', [
'<section class="user">',
'',
'  <h4>',
'    <a ng-link="users({\'id\': \'all\'})" translate>user.userlist</a>',
'    <span>/</span>',
'    <span translate>user.new_user</span>',
'  </h4>',
'',
'  <hr>',
'',
'  <div class="panel-body" ng-if="newUser.user">',
'    <hr>',
'    <div ng-inline="templates/userForm.tpl.html" ng-init="model=newUser.user;required=newUser.required"></div>',
'    <hr>',
'    <button ng-click="newUser.save()" class="btn btn-primary pull-right" translate>user.save</button>',
'    <a ng-link="users({id: \'all\'})" class="btn btn-link pull-right" translate>user.discard</a>',
'  </div>',
'',
'</section>',
'',''].join("\n"));
  }]);
})();